import { FormHelperText, Slider } from "@mui/material";
import PropTypes from "prop-types";

import { FormRow, FormSection, FormSectionHeader, InputContainer } from ".";

/**
 * Default light level slider configuration section.
 *
 * @param root0 - The component props.
 * @param root0.localSettings - The local settings state.
 * @param root0.updateLocalSettings - Callback to update local settings.
 * @param root0.commitSettings - Callback to commit settings changes.
 * @returns The rendered default light levels section.
 */
const SectionDefaultLightLevels = ({
    localSettings,
    updateLocalSettings,
    commitSettings,
}) => (
    <FormSection>
        <FormSectionHeader>
            <h2>Default Light Level</h2>
            <p>
                You can set a default light level here. This will be overridden
                if this group is controlled by a daylight harvesting sensor, the
                controller goes into manual control, or the push button override
                is active.
            </p>
        </FormSectionHeader>
        <FormRow>
            <InputContainer>
                <FormHelperText>Default Light Level (%)</FormHelperText>
                <Slider
                    value={localSettings.defaultLightLevel ?? 0}
                    valueLabelDisplay="auto"
                    onChange={(_, value) =>
                        updateLocalSettings({ defaultLightLevel: value })
                    }
                    onChangeCommitted={commitSettings}
                />
            </InputContainer>
        </FormRow>
    </FormSection>
);

SectionDefaultLightLevels.propTypes = {
    localSettings: PropTypes.object,
    updateLocalSettings: PropTypes.func,
    commitSettings: PropTypes.func,
};

export default SectionDefaultLightLevels;
